<template>
    <v-col cols="12" class="px-8" v-if="permisoVista('dashboard','r')">
      <v-snackbar v-model="error" top color="error">
		    	<ul>
		    		<li v-for="(e, i) in errores" :key="i">{{ e }}</li>
		    	</ul>
		    	<v-btn text @click="error = false"> Cerrar </v-btn>
		    </v-snackbar>
      <template v-if="!modoProyeccion ">
        <v-row class="mt-0">          
          <v-col cols="4" md="4" sm="4" class="align-self-end">
            <!-- @input="obtenerDatos" -->
            <datePicker
              v-model="filtros.desde"
                  format="YYYY-MM-DD"
                  label="Desde (Obligatorio)"
                  clearable
                  maxToday
                  
                  :disabled="cargando"
              :maxDate="filtros.hasta"
                ></datePicker>
          </v-col>
          <v-col cols="4" md="4" sm="4" class="align-self-end">
            <!-- @input="obtenerDatos" -->
            <datePicker
            v-model="filtros.hasta"
                  format="YYYY-MM-DD"
                  label="Hasta (Obligatorio)"
                  clearable
                  maxToday
                  
                  :disabled="cargando"
              :minDate="filtros.desde"
                ></datePicker>
          </v-col>
          <v-col cols="4" md="4" sm="4">
            
            <v-autocomplete
              v-model="filtros.idsTurnos"
              :items="turnos"
              item-value="idTurno"
              item-text="nombre"
              label="Turnos (Opcional)"
              hide-details
              clearable
              multiple
              chips
              deletable-chips
              :disabled="cargando"
              
              @click:clear="resetCampo(1)"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-target</v-icon> Filtros Avanzados (Opcionales)
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>         
                  
                  <v-col cols="4" md="4" sm="4">
                    <!-- @input="obtenerDatos" -->
                    <v-autocomplete
                      v-model="filtros.idsArticulos"
                      :items="articulos"
                      item-value="idArticulo"
                      :item-text="nombreArticulo"
                      label="Artículos"
                      hide-details
                      clearable
                      multiple
                      chips
                      deletable-chips
                      :disabled="cargando"
                      
                      @click:clear="resetCampo(2)"
                    >
                    </v-autocomplete>
                  </v-col>
                  <!-- <v-col cols="4" md="4" sm="4">
                    
                    <v-autocomplete
                      v-model="filtros.IdRoles"
                      :items="Roles"
                      item-value="idRol"
                      :item-text="nombreRol"
                      label="Rol"
                      hide-details
                      clearable
                      multiple
                      chips
                      deletable-chips
                      :disabled="cargando"
                      
                      @click:clear="resetCampo(3)"
                    >
                    </v-autocomplete>
                  </v-col> -->
                </v-row>
                
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
        <v-row>
          <v-btn color="primary" dark class="mb-2" @click="obtenerDatos">Consultar</v-btn>
          <!-- <download-btn
            
            className="my-4"
            color="blue darken-1"
            text
            @click="descargarReporte"
            label="Descargar Reporte de OEE"
          /> -->
        </v-row>
        <br>
      </template>
      <div v-if="viewData ">
        <v-row v-if="realizarPeticion && sameDay" class="px-0 ma-0">
        <v-col cols="12" class="ma-0 text-right text-subtitle-2 d-flex flex-column">
          Proxima Actualización en {{tiempo}}
          <div v-if="!modoProyeccion" class="text-right d-flex my-n5">
            <div class="ml-auto">
              <v-switch v-model="switch1"
               label="Desactivar actualización automática"
               @change="stopTimer"
              ></v-switch>
            </div>
          </div>
        </v-col>
      </v-row>       
      <!-- Grafica de roles -->
      <v-row v-if="!cargando && renderizar" class="justify-center ma-0 pa-0">
        <v-col cols="6" md="6" sm="6" class="text-center">
          <div class="d-flex align-center">
            <v-icon left>mdi-alert-circle-outline</v-icon> Alertas Atendidas
          </div>
          <apexchart  height="220" style="margin:auto;" width="100%":options="serie1" :series="chartOptions1" ></apexchart>
        </v-col>       
      </v-row>
      
      </div>
      <div v-if="cargandoData ">
        <v-col cols="12" md="12" sm="12" class="text-center">
                          <h4>Cargando</h4>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" class="text-center">
                          <v-progress-circular
                              :size="75"
                              color="green"
                              indeterminate
                          ></v-progress-circular>
                      </v-col>
      </div>
    </v-col>
  </template>
    
  <script>
  import { mapState } from 'vuex';
  import axios from "axios";
  import ICountUp from "vue-countup-v2";
  import moment from "moment";
  import DownloadBtn from '../../DownloadBtn.vue';
  
  
  export default {
      components: {
          ICountUp,
      DownloadBtn,
      
      },
    props: {
      modoProyeccion: {
        type: Boolean,
        default: false
      },
      update: {
        type: Number,
        default: 5
      },
          active: {
              type: Boolean,
              default: false,
          },
      },
      computed: {
    //   idTurnoActual(){
    //     const currentTime = new Date();
    //     const turnoActual = this.turnos.find(turno => {
    //       const start = this.$utils.strings.stringToTime(turno.inicio);
    //       const end = this.$utils.strings.stringToTime(turno.fin);
    //       // Manejar el caso en que el rango cruce la medianoche
    //       if (start > end) {
    //         return currentTime >= start || currentTime <= end;
    //       } else {
    //         return currentTime >= start && currentTime <= end;
    //       }
    //     });
    //     return turnoActual?.idTurno || null;
    //   },
      today(){
        return (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
      },
      ...mapState({
        nombreEmpresa: 'nombreEmpresa',
        oeeRendimientoLabel: 'oeeRendimientoLabel',
        nuevoReporteOee: 'nuevoReporteOee',
        formulaNyx: 'formulaNyx',
      }),
          realizarPeticion() {
              return this.$utils.isValid(this.filtros.desde) && this.$utils.isValid(this.filtros.hasta);
          },
          url() {
        //Como el endpoint cambia dependiendo de la variable de entorno, se hace una validacion para que tome el correcto
        var endpoint = 'ReporteRespuestaMantenimiento';//OEERangoTurnosNyx
        var url = `/Reportes/${endpoint}?Desde=${this.filtros.desde}&Hasta=${this.filtros.hasta}`;
        /* url += this.$utils.arrays.urlQuery(this.filtros.idsTurnos,"IdsTurnos",false); */
        if(this.filtros.idsTurnos != null)
          url += this.$utils.arrays.urlQuery(this.filtros.idsTurnos,"IdsTurnos",false);
        
        // url += this.$utils.arrays.urlQuery(this.filtros.idsAreas,"IdsAreas",false);
        // url += this.$utils.arrays.urlQuery(this.filtros.idsOTS,"IdsOTS",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsArticulos,"IdsArticulos",false);
        // url += this.$utils.arrays.urlQuery(this.filtros.idsMaquinaInstancias,"IdsMaquinasInstancias",false);
        // url += this.$utils.arrays.urlQuery(this.filtros.idsPersonas,"IdsPersonas",false);
        // url += this.$utils.arrays.urlQuery(this.filtros.idsClientes,"IdsClientes",false);
        return url;
          },
          tiempo(){
        return this.$utils.strings.toTime(this.segundos);
      },
      sameDay(){
        var desde = this.$utils.isValid(this.filtros.desde) ? moment(this.filtros.desde, "YYYY-MM-DD") : moment(1);
        var hasta = this.$utils.isValid(this.filtros.hasta) ? moment(this.filtros.hasta, "YYYY-MM-DD") : moment(1);
        return desde.isSameOrAfter(moment(),'day') || hasta.isSameOrAfter(moment(),'day');
      },      
      },
      data(){
      return {
        
        switch1: false,
      
      cargandoData:false,
      viewData:false,
      contador: 8,
          interval: null,
          segundos: 60,
          cargando: false,
      // expanded: [],
      // expanded1: [],
      // expanded2: [],
      filtros: {
        desde: null,
        hasta: null,
        idsTurnos: [],
        // idsAreas: [],
        // idsOTS: [],
        idsArticulos: [],
        // idsMaquinaInstancias: [],
        // idsPersonas: [],
        // idsClientes: []
      },
      turnos:[],
      areas:[],
      ots:[],
      articulos:[],
      maquinasIns:[],
      operadores:[],
      clientes:[],
      datos:[],
      datosDefault:[],
      serie1: [],
      chartOptions1:{
        chart: {
          id: 'roles',
          group: 'oee',
          type: 'bar',
          stacked: true,
          height: 300,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          },
        },
        responsive: [{
              breakpoint: 480,
              options: {
                legend: {
                  position: 'bottom',
                  offsetX: -10,
                  offsetY: 0
                }
              }
            }],
        plotOptions: {
              bar: {
                horizontal: false,
                borderRadius: 10,
                borderRadiusApplication: 'end', // 'around', 'end'
                borderRadiusWhenStacked: 'last', // 'all', 'last'
                dataLabels: {
                  total: {
                    enabled: true,
                    style: {
                      fontSize: '13px',
                      fontWeight: 900
                    }
                  }
                }
              },
            },
        dataLabels: {
            enabled: false, // Ocultar los valores de la serie
          },
        // colors: ['#118dff'],
        xaxis: {
          type: 'string',
          labels: {
            // datetimeUTC: false
          },
          tooltip: {
            enabled: false,
          }
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2)+'%';
            }
          },
          min: 0,
          tickAmount: 5,
        },
        legend: {
              position: 'right',
              offsetY: 40
            },
        fill: {
              opacity: 1
            }
      },    

      renderizar: false,
      
      countVel:0,
      mismoDia: false,
      errores: [],
      error: false,
      }
    },
      methods: {
      nombreArticulo:(articulo) => `[${articulo.codigo}] - ${articulo.nombre}`,
      nombreRol: rol => `${rol.rol}`,
    //   nombrePersona: (persona) => persona.nombre + " " + persona.paterno + " " + persona.materno,
      getRoundedHour(date) {
        // Crear una nueva fecha con la misma hora pero los minutos y segundos ajustados a 0
        const roundedDate = new Date(date);
        roundedDate.setMinutes(0, 0, 0);
        return roundedDate.getTime();
      },
      
      generarSerie(){
        var atendido =
          {
            name: "Atendidos",
            data: [],
          };
        // var desatendido =
        //   {
        //     name: "Desatendidos",
        //     data: [],
        //   };
        var series = [];  
  
        if(this.datos != null && this.datos.length > 0){
          atendido.data = this.datos.map(d =>{    
            var detalle = `<span>Atendidos: ${d.reportesAtendidos}</span><br>`+
              `<span>Desatendidos: ${d.reportesDesatendidos}</span>`;       
            return {
              z: detalle,
              x: d.rol,
              y: d.porcentajeAtendidos,
            }
          });
          // desatendido.data = this.datos.map(d =>{            
          //   return {
          //     z: d.rol,
          //     x: d.rol,
          //     y: d.porcentajeDesatendidos,
          //   }
          // });
        }
        series.push(atendido);
        // series.push(desatendido);
        
        return series; 
      },
      
      formatoFechaHora(fecha) {
         const fechaObj = new Date(fecha);
         const dia = String(fechaObj.getDate()).padStart(2, '0');
         const mes = String(fechaObj.getMonth() + 1).padStart(2, '0');
          const anio = fechaObj.getFullYear();
          // const horas = String(fechaObj.getHours()).padStart(2, '0');
          // const minutos = String(fechaObj.getMinutes()).padStart(2, '0');
  
          return new Date(anio, mes - 1, dia);//, horas, minutos
      },
      
      chartOptionsGenerador(){
        
        return  {
          chart: {
            id: 'rol',
            group: 'roles',
            type: 'bar',
            stacked: true,
            height: 300,
            toolbar: {
              show: false
            },
          },
          
          tooltip: {
              custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                const data =  w.globals.initialSeries[seriesIndex].data[dataPointIndex];//series[seriesIndex][dataPointIndex];
                
                return '<div style="padding: 8px;">' +
                  `<span>${data.x}</span><br>` +
                  `<span> ${data.y}%</span><br>` +
                  data.z +
                  '</div>';
              },
            },
          responsive: [{
              breakpoint: 480,
              options: {
                legend: {
                  position: 'bottom',
                  offsetX: -10,
                  offsetY: 0
                }
              }
            }],
          plotOptions: {
              bar: {
                horizontal: false,
                borderRadius: 10,
                borderRadiusApplication: 'end', // 'around', 'end'
                borderRadiusWhenStacked: 'last', // 'all', 'last'
                dataLabels: {
                  total: {
                    enabled: false,
                    style: {
                      fontSize: '13px',
                      fontWeight: 900
                    }
                  }
                }
              },
            },
          dataLabels: {
            enabled: false, // Ocultar los valores de la serie
          },
          // colors: [color],
          xaxis: {
            type: 'string',
            labels: {
              // datetimeUTC: false
            },
            tooltip: {
              enabled: true,
            }
          },
          yaxis: {
            labels: {
              formatter: function (val) {
                return val.toFixed(2)+'%';
              }
            },
            min: 0,
            max:100,
            tickAmount: 5,
          },
          legend: {
              position: 'right',
              offsetY: 40
            },
          fill: {
              opacity: 1
            }

        };
      },     
      initialize() {
        this.getTurnos();
        // this.getAreas();
        // this.getOTS();
        this.getArticulos();
        // this.getMaquinasIns();
        // this.getOperadores();
        // this.getClientes();
        // this.getRoles();
        
          },
      resetCampo(posicion){
        switch (posicion) {
            case 1:
                this.filtros.idsTurnos = [];
                break;
            case 2:
                this.filtros.idsArticulos = [];
                break;
            // case 3:
            //     this.filtros.idsRoles = [];
            //     break;
          default:
            break;
        }
      },
      stopTimer(newValue) {
        if (newValue)
          this.active = true; 
          else
          this.active = false;
      },
          obtenerDatos() {
              if (this.validate()) return;              
              
              if (!this.realizarPeticion || this.cargando) return;
  
            //   if(this.modoProyeccion){
            //     this.filtros.idsTurnos = this.idTurnoActual;
            //   }
              
              this.cargando = true;
              this.segundos = 60;
              this.cargandoData = true;
              this.mismoDia=this.filtros.desde==this.filtros.hasta? true : false;
              axios
              .get(this.url)
              .then((response) => {
                if(response.data == null){
                  this.datos = this.datosDefault;   
                  
                }else{
                  this.datos = response.data;                 
                }
                this.chartOptions1 = this.generarSerie();
                this.serie1 = this.chartOptionsGenerador();

                
                this.renderizar = true;
                this.cargando = false;
                this.cargandoData = false;
                this.viewData = true;
          
              })
              .catch((error) => {
                this.datos = this.datosDefault; 
                this.chartOptions1 = this.generarSerie();
                this.serie1 = this.chartOptionsGenerador();

                
                this.cargando = false;
                this.viewData = true;
                this.cargandoData = false;
                if(error.response.status == 404){
                  this.datos.calidad = 100;
                  this.datos.disponibilidad = 100;
                  this.datos.eficiencia = 100;
                  this.datos.oee = 100;
                  this.errores = [];
                  this.error = true;
                  this.errores.push(
							      "No se han programado actividades para este turno"
						      );
                }
                console.log(error);
              });
        this.countVel++
          },
          getTurnos() {
              axios
              .get("/Turnos")
              .then((response) => {
                  this.turnos = response.data;
              })
              .catch((error) => {
                  console.log(error);
              });
          },
      
      getArticulos() {
              axios
                  .get("/Articulos/OTS")
                  .then((response) => {
                      this.articulos = response.data;
                  })
                  .catch((error) => {
                      console.log(error);
                  });
          },
      getMaquinasIns(){
        axios
        .get("/MaquinaInstancias")
        .then(response => {
          this.maquinasIns = response.data;
        })
        .catch(error => {
          console.log(error);
        })
      },
      
    //   url2(path) {
    //     var url = `${path}?Desde=${this.filtros.desde}&Hasta=${this.filtros.hasta}`;
    //     url += this.$utils.arrays.urlQuery(this.filtros.idsTurnos,"IdsTurnos",false);
    //     url += this.$utils.arrays.urlQuery(this.filtros.idsAreas,"IdsAreas",false);
    //     url += this.$utils.arrays.urlQuery(this.filtros.idsOTS,"IdsOTS",false);
    //     url += this.$utils.arrays.urlQuery(this.filtros.idsArticulos,"IdsArticulos",false);
    //     url += this.$utils.arrays.urlQuery(this.filtros.idsMaquinaInstancias,"IdsMaquinasInstancias",false);
    //     url += this.$utils.arrays.urlQuery(this.filtros.idsPersonas,"IdsPersonas",false);
    //     url += this.$utils.arrays.urlQuery(this.filtros.idsClientes,"IdsClientes",false);
    //     return url;
    //       },
    //   descargarReporte(){
    //     var datetime = moment().format('YYYYMMDDHHmmss');//OEEReport
    //     this.$utils.axios.downloadFile(this.url2("/OEEV2/OEEReportTurnos"),'GET','reporte-oee-'+datetime+'.xlsx','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    //   },
      
     
      validate() {
			this.errores = [];
      
			if (this.filtros.desde==null || this.filtros.hasta==null) {
				this.errores.push(
							"La consulta debe de incluir una fecha de inicio y una fecha de fin"
						);
        
			}			
			this.error = this.errores.length > 0;
			return this.errores.length > 0 ;
		  },           
    },
    filters: {
      formatToPercentage(value){
        return (value ).toFixed(2) + "%";//* 100
      },
      formatStringFecha(value){
        return value.slice(0,-3).split("T").join(" ");
      }
    },
      mounted() {
      
      if(this.modoProyeccion){
        this.filtros.desde = this.today;
        this.filtros.hasta = this.today;
        this.segundos = 0;
      }
      
          this.interval = setInterval(() => {
              if (!this.active) return;
              if(this.segundos <= 0 && this.sameDay) this.obtenerDatos();
        else this.segundos -= 1;
          }, 1000);
          this.initialize();
      },
      destroyed() {
          clearInterval(this.interval);
      },
  };
  </script>